import React from 'react'

const NewUserForm = () => {
  return (
    <div className='text-white'>NewUserForm</div>
  )
}

export default NewUserForm